module.exports = __webpack_public_path__ + "static/winds-3-8633fcddcb1475674e73cf83c732b04f.jpg";